import * as React from 'react';
import CloudUpload from '@mui/icons-material/CloudUpload';
import { Button, Tooltip } from "@mui/material";
import { buildSchema, buildProperty, buildCollection, ExtraActionsParams } from "@camberi/firecms";
import { getFunctions, httpsCallable } from "firebase/functions";
import { initializeApp, getApp } from "firebase/app";
import { firebaseConfig } from "../firebaseConfig";


export default class Notifications {

    constructor() {

    }

    static BuildCollection(isadmin: boolean, issuperadmin: boolean, groupname: string) {
        return buildCollection({
            path: "mailInGame",
            group: groupname,
            exportable: false,
            schema: Notifications.schema(),
            name: "Notifications",
            extraActions: Notifications.actions,
            permissions: ({ entity, path, user, authController, context }) => {
                return ({
                    read: isadmin,
                    create: isadmin,
                    update: isadmin,
                    delete: isadmin
                });
            },
        });
    }

    static actions(extraActionParams: ExtraActionsParams) {
        const disabled = extraActionParams.selectionController.selectedEntities.length === 0;

        const copyToLive = async () => {
            if (extraActionParams.selectionController.selectedEntities.length === 0) return;

            const selectedEntity = extraActionParams.selectionController.selectedEntities[0];
            const snackbar = extraActionParams.context.snackbarController;
            const user = extraActionParams.context.authController.user;

            if (!user) {
                snackbar.open({
                    type: "error",
                    title: "Error",
                    message: "User not authenticated"
                });
                return;
            }

            try {
                let app;
                try {
                    app = getApp();
                } catch {
                    app = initializeApp(firebaseConfig);
                }
                const functions = getFunctions(app, "europe-west3");
                const copyToLiveFunction = httpsCallable(functions, "copyDocumentToLive");

                await copyToLiveFunction({
                    props: {
                        collection: "mailInGame"
                    },
                    userID: user.uid,
                    documentID: selectedEntity.id
                });

                snackbar.open({
                    type: "success",
                    title: "Copy to Live",
                    message: "Notification copied to live project successfully"
                });
            } catch (error) {
                snackbar.open({
                    type: "error",
                    title: "Error",
                    message: `Failed to copy notification to live: ${error}`
                });
            }
        };

        return [
            <Tooltip title="Copy selected notification to live project" key="copy-live-tip">
                <Button disabled={disabled} onClick={copyToLive} color="primary" key="copy-live">
                    <CloudUpload />
                </Button>
            </Tooltip>
        ];
    }

    static schema() {
        return buildSchema({
            name: "Notifications",
            properties: {
                image: buildProperty({
                    title: "Image",
                    dataType: "string",
                    config: {
                        storageMeta: {
                            mediaType: "image",
                            storagePath: "mailInGame",
                            acceptedFiles: ["image/*"]
                        }
                    }
                }),
                creationDate: {
                    title: "Creation date",
                    dataType: "timestamp"
                },
                userIDs: {
                    title: "User IDs",
                    dataType: "array",
                    of: {
                        dataType: "string"
                    }
                },
                titleEn: { title: "Title (English)", dataType: "string" },
                titleDe: { title: "Title (German)", dataType: "string" },
                titleEs: { title: "Title (Spanish)", dataType: "string" },
                titleFr: { title: "Title (French)", dataType: "string" },
                titleIt: { title: "Title (Italian)", dataType: "string" },
                titlePt: { title: "Title (Portuguese)", dataType: "string" },
                titleRu: { title: "Title (Russian)", dataType: "string" },
                titleTr: { title: "Title (Turkish)", dataType: "string" },
                titleVi: { title: "Title (Vietnamese)", dataType: "string" },
                titleZhCn: { title: "Title (Simplified Chinese)", dataType: "string" },
                titleZhTw: { title: "Title (Traditional Chinese)", dataType: "string" },

                bodyEn: {title: "Body (EN)",dataType: "string", config: { multiline: true } },
                bodyDe: {title: "Body (German)",dataType: "string", config: { multiline: true } },
                bodyEs: {title: "Body (Spanish)",dataType: "string", config: { multiline: true } },
                bodyFr: {title: "Body (French)",dataType: "string", config: { multiline: true } },
                bodyIt: {title: "Body (Italian)",dataType: "string", config: { multiline: true } },
                bodyPt: {title: "Body (Portuguese)",dataType: "string", config: { multiline: true } },
                bodyRu: {title: "Body (Russian)",dataType: "string", config: { multiline: true } },
                bodyTr: {title: "Body (Turkish)",dataType: "string", config: { multiline: true } },
                bodyVi: {title: "Body (Vietnamese)",dataType: "string", config: { multiline: true } },
                bodyZhCn: {title: "Body (Simplified Chinese)",dataType: "string", config: { multiline: true } },
                bodyZhTw: {title: "Body (Traditional Chinese)",dataType: "string", config: { multiline: true } },
            }
        });
    }
}
